/* eslint-disable react/prop-types */
import React, { useMemo } from 'react';
import { Icon, ListItemText, Tooltip } from '@mui/material';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import AppBadge from '@crema/core/AppBadge';
import AppNavLink from '@crema/core/AppNavLink';
import Box from '@mui/material/Box';
import { checkPermission } from '../../../../../utility/helper/RouteHelper';
import { useAuthUser } from '../../../../../utility/AuthHooks';
import VerticalNavItem from './VerticalNavItem';
import * as icon from '@mui/icons-material';
import { toggleNavCollapsed } from 'redux/actions';
import { useDispatch } from 'react-redux';

const VerticalItem = ({ level, item }) => {
  const { user } = useAuthUser();
  const dispatch = useDispatch();

  const hasPermission = useMemo(
    () => checkPermission(item.permittedRole, user.role),
    [item.permittedRole, user.role],
  );

  const handleClick = () => {
    // Close sidebar menu every item clicked
    dispatch(toggleNavCollapsed())
    if (item.isNewWindow === '1') {
      window.open(item.url)
    }
  }

  const IconComponent = icon[item?.icon];

  if (!hasPermission) {
    return null;
  }

  return (
    <VerticalNavItem
      level={level}
      button
      component={AppNavLink}
      exact={item?.exact}
      onClick={() => handleClick()}
      to={item.isNewWindow !== '1' ? item.url : ''}
      activeClassName={item.isNewWindow === '1' || item.isAction === '1' ? '' : 'active'}
    >
      {item.icon && (
        <Box component='span' sx={{ width: 30, height: 30, display: 'flex', alignItems: 'center', justifyContent: 'center', mr: 3 }}>
          <Icon
            color='action' className={clsx('nav-item-icon')}
            sx={{
              fontSize: { xs: 16, xl: 18 },
            }}
          >
            <IconComponent sx={{ fontSize: '20px' }} />
          </Icon>
        </Box>
      )}
      {
        item.tooltip &&
        <Tooltip title={item?.tooltip} placement='top' arrow>
          <ListItemText
            className='nav-item-content'
            primary={item?.messageId || item?.message_id}
            classes={{ primary: 'nav-item-text' }}
            style={{ wordWrap: 'break-word !important', whiteSpace: 'pre-wrap !important' }}
          />
        </Tooltip>
      }
      {
        !item.tooltip &&
        <ListItemText
          className='nav-item-content'
          primary={item.messageId || item?.message_id}
          classes={{ primary: 'nav-item-text' }}
          sx={{ wordWrap: 'break-word !important', whiteSpace: 'pre-wrap !important' }}
        />
      }
      {item.count && (
        <Box sx={{ mr: 3.5 }} className='menu-badge'>
          <AppBadge count={item.count} color={item.color} />
        </Box>
      )}
    </VerticalNavItem>
  );
};

VerticalItem.propTypes = {
  item: PropTypes.shape({
    id: PropTypes.string.isRequired,
    title: PropTypes.string,
    tooltip: PropTypes.any,
    icon: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
    permittedRole: PropTypes.oneOfType([PropTypes.array, PropTypes.string]),
    exact: PropTypes.bool,
    messageId: PropTypes.string,
    count: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    url: PropTypes.string,
    color: PropTypes.string,
  }),
  level: PropTypes.number,
};

VerticalItem.defaultProps = {};

export default React.memo(VerticalItem);
